import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const COLORS = {
    spending: '#1e85e5',
    corehealth: '#8B46D0',
    teladoc: '#00BBB2'
};

const LABELS = {
    spending: 'Spending',
    corehealth: 'CoreHealth',
    teladoc: 'Teladoc'
};

const MiniDonutChart = ({ data, total, formatCurrency, size = 'default', showCenter = true, showLegend = true }) => {
    // filter out zero values
    const filteredData = data.filter(d => d.value > 0);

    if (filteredData.length === 0) {
        return (
            <div className={`flex items-center justify-center ${size === 'small' ? 'h-[100px]' : 'h-[180px]'} text-gray-400 text-sm`}>
                No data available
            </div>
        );
    }

    // size configurations
    const sizeConfig = size === 'small'
        ? { height: 100, innerRadius: 30, outerRadius: 45 }
        : { height: 180, innerRadius: 50, outerRadius: 70 };

    return (
        <div className="relative">
            <ResponsiveContainer width="100%" height={sizeConfig.height}>
                <PieChart>
                    <Pie
                        data={filteredData}
                        innerRadius={sizeConfig.innerRadius}
                        outerRadius={sizeConfig.outerRadius}
                        paddingAngle={2}
                        dataKey="value"
                        strokeWidth={0}
                    >
                        {filteredData.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={COLORS[entry.type] || '#6b7280'}
                            />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>

            {/* center label */}
            {showCenter && (
                <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                    <span className="text-xs text-gray-400">Total</span>
                    <span className={`${size === 'small' ? 'text-sm' : 'text-lg'} font-bold text-gray-900`}>
                        {formatCurrency(total)}
                    </span>
                </div>
            )}

            {/* legend */}
            {showLegend && (
                <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mt-2">
                    {filteredData.map((entry) => (
                        <div key={entry.type} className="flex items-center gap-1.5">
                            <span
                                className="w-2.5 h-2.5 rounded-full"
                                style={{ backgroundColor: COLORS[entry.type] }}
                            />
                            <span className="text-xs text-gray-600">
                                {LABELS[entry.type] || entry.type}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MiniDonutChart;
